import React, { useState, useEffect } from 'react';
import ChatInterface from '../components/ChatInterface';
import MissionControlCenter from '../components/MissionControlCenter';
import getEnvironmentConfig from '../config/environment';

function ChatAndDocPage({
  initialDocKey,
  initialDocUrl,
  initialDocContent,
  setDocKey,
  setDocContent,
  isPackage,
  packageUrls,
  setIsPackage,
  setPackageUrls
}) {
  const [docUrl, setLocalDocUrl] = useState(initialDocUrl || '');
  const [docContent, setLocalDocContent] = useState(initialDocContent || '');
  const [draftRevision, setDraftRevision] = useState(null);
  const [localIsPackage, setLocalIsPackage] = useState(isPackage || false);
  const [localPackageUrls, setLocalPackageUrls] = useState(packageUrls || null);

  const currentDocKey = initialDocKey || '';

  // Get API endpoint from environment configuration
  const config = getEnvironmentConfig();
  const DOC_CREATION_API_BASE = config.aws_cloud_logic_custom.find(api => api.name === 'DocCreationAPI')?.endpoint;
  
  if (!DOC_CREATION_API_BASE) {
    console.error('Failed to get DocCreationAPI endpoint from environment config', { config });
  }

  console.log('=== ChatAndDocPage Component State ===');
  console.log('- docUrl state:', docUrl);
  console.log('- localIsPackage:', localIsPackage);
  console.log('- localPackageUrls:', localPackageUrls);
  console.log('- currentDocKey:', currentDocKey);
  console.log('=====================================');

  useEffect(() => {
    if (initialDocUrl) {
      setLocalDocUrl(initialDocUrl);
    }
    if (initialDocContent) {
      setLocalDocContent(initialDocContent);
    }
  }, [initialDocUrl, initialDocContent]);

  useEffect(() => {
    console.log('=== docUrl State Changed ===');
    console.log('New docUrl value:', docUrl);
    console.log('===========================');
  }, [docUrl]);

  useEffect(() => {
    // Update parent state when local state changes
    if (setIsPackage) {
      setIsPackage(localIsPackage);
    }
    if (setPackageUrls) {
      setPackageUrls(localPackageUrls);
    }
  }, [localIsPackage, localPackageUrls, setIsPackage, setPackageUrls]);

  const handleSetDocContent = (content) => {
    setLocalDocContent(content);
    if (setDocContent) {
      setDocContent(content);
    }
  };

  const handleDocumentCreated = (docKey, isDocPackage = false, pkgUrls = null) => {
    console.log('=== handleDocumentCreated Debug ===');
    console.log("Document created with key:", docKey, "isPackage:", isDocPackage, "packageUrls:", pkgUrls);
    console.log('Type of isDocPackage:', typeof isDocPackage);
    console.log('Type of pkgUrls:', typeof pkgUrls);
    console.log('Current docUrl state:', docUrl);
    console.log('=================================');
    
    if (docKey && setDocKey) {
      setDocKey(docKey);
    }
    if (docKey) {
      const newUrl = `${DOC_CREATION_API_BASE}/download/${docKey}`;
      console.log("Setting document URL in parent via handleDocumentCreated:", newUrl);
      setLocalDocUrl(newUrl);
      console.log("Called setLocalDocUrl with:", newUrl);
    }
    
    // Update package information
    setLocalIsPackage(isDocPackage);
    
    // Important: Extract packageUrls from the response
    if (pkgUrls) {
      console.log("Setting package URLs:", pkgUrls);
      setLocalPackageUrls(pkgUrls);
    }
  };

  const handleDraftRevision = (revisionData) => {
    console.log("ChatAndDocPage got a draft revision:", revisionData);
    if (!revisionData || typeof revisionData.revisedHtml !== 'string') {
      return;
    }
    setDraftRevision(revisionData);
    setLocalDocContent(revisionData.revisedHtml);
    if (setDocContent) {
      setDocContent(revisionData.revisedHtml);
    }
  };

  const handlePackageUrlsUpdate = (urls) => {
    console.log("Updating package URLs:", urls);
    setLocalPackageUrls(urls);
  };

  return (
    <div className="flex h-full">
      <div className="w-1/3 border-r h-full overflow-hidden flex flex-col">
        <div className="p-4 bg-gray-100 border-b">
          <h2 className="font-bold">Chat with Assistant</h2>
        </div>
        <div className="flex-grow overflow-auto">
          <ChatInterface
            setDocKey={setDocKey}
            setDocUrl={(url) => {
              console.log('ChatInterface calling setDocUrl with:', url);
              setLocalDocUrl(url);
              console.log('After setLocalDocUrl, docUrl state will be:', url);
            }}
            setDocContent={handleSetDocContent}
            onDocumentCreated={handleDocumentCreated}
            currentDocKey={currentDocKey}
            onDraftRevision={handleDraftRevision}
            setIsPackage={setLocalIsPackage}
            setPackageUrls={handlePackageUrlsUpdate}
            isPackage={localIsPackage}
            DOC_CREATION_API_BASE={DOC_CREATION_API_BASE}
          />
        </div>
      </div>

      <div className="w-2/3 h-full flex flex-col overflow-hidden">
        <div className="p-4 bg-gray-100 border-b flex items-center">
          <h2 className="font-bold">Mission Control Center</h2>
        </div>

        <div className="flex-grow overflow-auto">
          {console.log('=== Rendering MissionControlCenter from ChatAndDocPage ===')}
          {console.log('Passing docUrl:', docUrl)}
          {console.log('Passing docContent:', docContent ? 'Has content' : 'No content')}
          {console.log('Passing isPackage:', localIsPackage)}
          {console.log('Passing packageUrls:', localPackageUrls)}
          {console.log('================================================')}
          <MissionControlCenter
            docUrl={docUrl}
            docContent={docContent}
            setDocContent={handleSetDocContent}
            isPackage={localIsPackage}
            packageUrls={localPackageUrls}
            DOC_CREATION_API_BASE={DOC_CREATION_API_BASE}
          />
        </div>
      </div>
    </div>
  );
}

export default ChatAndDocPage;